import styled from "styled-components";

import { Title, SubTitle, Header } from "./atoms/titles";
import logo from "../utils/img/kuf3.png";
import { StyledP } from "./atoms/text";
import { blue, darkGreen, lightGray, white } from "../utils/color";
import { Fragment } from "react";
import { HeaderLogo } from "./atoms/logoImages";

const RegContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	font-family: "Noto Sans KR", sans-serif;
	width: 100%;
	padding: 20px 30px 90px 30px;
	box-sizing: border-box;
	background-color: ${lightGray};
`;

const RegSubContainer = styled.div`
	margin: 10px 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const ContactUl = styled.ul`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	list-style-type: None;
	padding: 0;
	margin: 0;
`;

const ContactLi = styled.li`
	font-size: 15px;
	margin-bottom: 10px;
`;

const RegLink = styled.a`
	background-color: ${lightGray};
	border: 1px solid ${(props) => props.mainColor};
	width: 130px;
	height: 130px;
	font-size: 20px;
	font-weight: 500;
	color: ${(props) => props.mainColor};
	border-radius: 50%;
	text-decoration: none;
	text-align: center;
	box-sizing: border-box;
`;

const RegLinkContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const RegLinkTitle = styled.h2`
	margin: 0 0 10px 0;
	font-size: 20px;
`;

const RegLinkText = styled.span`
	color: #636363;
	font-size: 13px;
	text-decoration: underline;
`;

export default function Registration() {
	const contactList = [
		["Tel: ", "02-761-8017"],
		["Email: ", "unhabitat@unhabitat.or.kr"],
	];
	return (
		<Fragment>
			<Header>
				<HeaderLogo src={logo} />
			</Header>
			<RegContainer>
				<Title color={white}>참가등록</Title>
				<StyledP color='#424242'>
					좌석이 제한된 관계로 반드시 사전 등록을 부탁드립니다.
				</StyledP>
				<RegSubContainer>
					<RegLink
						href='https://kuf.kr/registration'
						target='_blank'
						mainColor={darkGreen}
					>
						<RegLinkContainer>
							<RegLinkTitle>사전등록</RegLinkTitle>
							<RegLinkText>바로가기</RegLinkText>
						</RegLinkContainer>
					</RegLink>
				</RegSubContainer>
				<RegSubContainer>
					<RegLink href='https://kuf.kr' target='_blank' mainColor={blue}>
						<RegLinkContainer>
							<RegLinkTitle>홈페이지</RegLinkTitle>
							<RegLinkText>바로가기</RegLinkText>
						</RegLinkContainer>
					</RegLink>
				</RegSubContainer>
				<RegSubContainer>
					<SubTitle>|&nbsp; 문&nbsp;&nbsp; &nbsp;&nbsp;의 &nbsp;|</SubTitle>
					<ContactUl>
						{contactList.map((c, i) => {
							return (
								<ContactLi key={i}>
									<span>
										<strong>{c[0]}</strong>
									</span>
									<span>{c[1]}</span>
								</ContactLi>
							);
						})}
					</ContactUl>
				</RegSubContainer>
			</RegContainer>
		</Fragment>
	);
}
